'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



// WEBPACK FOOTER //
// ./~/rp-react-common/~/axios/lib/cancel/isCancel.js